<template>

    <button
        type="button"
        class="flex flex-col items-center justify-center"
        @click="handleClickButton">

            <span class=" w-16 h-16 rounded-full flex items-center justify-center shadow-md pointer-events-none" :class="spanStyle">
                <slot name="icon" :state="activite"></slot>

            </span>

            <p class="pointer-events-none">
                {{ label }}
            </p>
    </button>

</template>


<script>


export default {

    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },

        label: {
            type: String,
            required: true,
        },

        spanStyle: {
            type: String,
            default: '',
        }
    },

    emits: ['update:modelValue', 'click'],

    data() {
        return {
            activite: this.$props.modelValue,
        }
    },


    watch: {
        modelValue() {
            this.$data.activite = this.$props.modelValue
        },
    },

    methods: {
        handleClickButton() {
            this.activite = !this.activite
            this.$emit('update:modelValue', this.$data.activite)

            this.$emit('click')
        }
    },
}


</script>
